import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { TabsButtons } from '@/components'
import { Tab, TabsButtonsProps } from '@/components/common/Tabs/types'

export const SustainabilityTabs: React.FC = () => {
    const { t } = useTranslation('translations')
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const config: Array<Omit<Tab, 'content'> & { path: string }> =
        useMemo(() => {
            const baseTabs = [
                {
                    id: 'totalEmissions',
                    label: t('sustainability.tabs.buttons.total_emissions'),
                    path: '/sustainability/total-emissions',
                },
                {
                    id: 'ghgEmissionsReport',
                    label: t(
                        'sustainability.tabs.buttons.ghg_emissions_report'
                    ),
                    path: '/sustainability/ghg-emissions-report',
                },
                {
                    id: 'electricityMixUsage',
                    label: t(
                        'sustainability.tabs.buttons.electricity_mix_usage'
                    ),
                    path: '/sustainability/electricity-mix-usage',
                },
            ]

            return baseTabs
        }, [t])

    const onChange = useCallback(
        (id: string) => {
            const obj = config.find((obj) => obj.id === id)

            if (obj) {
                void navigate({ to: obj.path })
            }
        },
        [config, navigate]
    )

    const tabs: TabsButtonsProps['tabs'] = config.map(
        ({ path: _path, ...tab }) => tab
    )
    const activeTab = config.find((obj) => obj.path === pathname)?.id ?? ''

    return (
        <>
            <TabsButtons
                tabs={tabs}
                activeTabId={activeTab}
                onChange={onChange}
                className="grid h-full grid-rows-[auto,1fr]"
            />
        </>
    )
}
